export default "__VITE_ASSET__2ec4d56e__"